import { useTranslations } from "next-intl";

export const useTranslate = (defaultNs?: string) => {
  const t = useTranslations(defaultNs);
  return t;
};
